import { useRef, useState, useEffect, useContext } from 'react';
import { CurrentUserContext } from '../../context/CurrentUserContext';
import defaultPP from '../../images/pp_default.png';
import '../ProfileSideBar/ProfileSideBar.css';


export const API_URL = window.location.hostname === "localhost"
  ? "http://localhost:4000/api"
  : process.env.REACT_APP_API_URL || "https://api.vixacademy.com/api";
  
console.log("Profile Upload Api:", process.env.REACT_APP_API_URL);
  
const ProfilePictureUploader = ({ onImageUpload }) => {
  const { currentUser } = useContext(CurrentUserContext);
  const fileInputRef = useRef(null);
  const [localTempPreview, setLocalTempPreview] = useState(null);

  const preview = localTempPreview
    ? localTempPreview
    : currentUser?.profilePicture
      ? (currentUser.profilePicture.startsWith('http')
        ? currentUser.profilePicture
        : `${API_URL}${currentUser.profilePicture.startsWith('/') ? '' : '/'}${currentUser.profilePicture}`)
      : defaultPP;

  const handleImageClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file || !currentUser?._id) {
      console.error('Missing file or user ID');
      return;
    }

    const tempUrl = URL.createObjectURL(file);
    setLocalTempPreview(tempUrl);

    const formData = new FormData();
    formData.append('profilePicture', file);

    try {
      const token = localStorage.getItem('token');
      if (!token) {
        console.error('No token found');
        return;
      }

      const res = await fetch(`${API_URL}/users/${currentUser._id}/profile`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
        credentials: 'include',
        body: formData,
      });

      if (!res.ok) {
        const text = await res.text();
        console.error('Server error:', text);
        return;
      }

      const data = await res.json();
      if (res.ok) {
        const updatedUser = {
          ...data.user,
          profilePicture: data.user.profilePicture.startsWith('http')
            ? data.user.profilePicture
            : `${API_URL}${data.user.profilePicture.startsWith('/') ? '' : '/'}${data.user.profilePicture}`
        };
      
        onImageUpload(updatedUser);  
        localStorage.setItem('user', JSON.stringify(updatedUser));  
        setLocalTempPreview(null);
      } else {
        console.error('Upload error:', data.error);
      }
    } catch (err) {
      console.error('Error occurred:', err);
    } finally {
      if (fileInputRef.current) {
        fileInputRef.current.value = null;
      }
    }
  };

  return (
    <div className="profile-pic-container" style={{ textAlign: 'center' }}>
      <img
        src={preview}
        alt="Profile"
        className="profile-pic"
        onClick={currentUser && currentUser._id ? handleImageClick : undefined}
        onError={(e) => { e.target.src = defaultPP; }}
        style={{ cursor: currentUser && currentUser._id ? 'pointer' : 'default', borderRadius: '50%'}}
      />
      <span className="profile-picSub"
          onClick={currentUser && currentUser._id ? handleImageClick : undefined}
          style={{ cursor: currentUser && currentUser._id ? 'pointer' : 'default'}}>
            Click to change profile picture
      </span>
      <input
        type="file"
        accept="image/*"
        ref={fileInputRef}
        onChange={handleFileChange}
        style={{ display: 'none' }}
      />
    </div>
  );
};

export default ProfilePictureUploader;
